import { makeStyles } from '@rbx/ui';
import { engineRevampMonospaceTextStyle } from '@modules/ui/shared/utils/styles';

const useReferenceMemberSignatureStyles = makeStyles()((theme) => {
  return {
    signatureContainer: {
      ...engineRevampMonospaceTextStyle,
      border: '1px solid',
      borderColor: theme.palette.components.divider,
      padding: '12px',
      borderRadius: '4px',
      backgroundColor: theme.palette.surface[100],
    },
    memberName: {
      ...engineRevampMonospaceTextStyle,
      display: 'inline-block',
      marginRight: '4px',
    },
    multilineSignature: {
      display: 'flex',
      flexDirection: 'column',
      ...engineRevampMonospaceTextStyle,
    },
    parametersContainer: {
      paddingLeft: '24px',
      ...engineRevampMonospaceTextStyle,
    },
    parentheses: {
      ...engineRevampMonospaceTextStyle,
      display: 'inline',
      marginRight: '4px',
    },
  };
});

export default useReferenceMemberSignatureStyles;
